<template>
<div>


      <el-row style="width: 98%;">
      <el-col span="20">
        <el-input v-model="propertyId" style="width: 50%;" placeholder="查看一个资产的变更记录的ID"></el-input>
         <el-button type="primary" @click="selectPropertyId">查看一个资产的变更记录</el-button>
      </el-col>
      </el-row>






    <el-table
        :data="tableData"
        style="width: 100%;margin-top: 5%;">

        <el-table-column
          prop="propertyId"
          label="资产编号"
          width="180">
        </el-table-column>


        <el-table-column
          prop="propertyRecordId"
          label="变更编号"
          width="180">
        </el-table-column>

        <el-table-column
          prop="afterUsername"
          label="变更后使用人的名字"
          width="180">
        </el-table-column>

        <el-table-column
          prop="beforeUsername"
          label="变更前使用人的名字"
          width="180">
        </el-table-column>

        <el-table-column
          prop="propertyName"
          label="资产名称"
          width="180">
        </el-table-column>



          <el-table-column
            prop="recordState"
            label="变更状态"
            width="180">

            <template slot-scope="scope">
              <el-tag
              @click="selectRecord(scope.row.recordState)"
              :type = "scope.row.recordState == 1?'':(scope.row.recordState==2?'success':'danger')">
                <div v-if="scope.row.recordState == 1">审核中</div>
                <div v-if="scope.row.recordState == 2">变更已完成</div>
              </el-tag>
            </template>

          </el-table-column>

        <el-table-column
          label="创建时间"
          width="180">
          <template slot-scope="scope">{{ Date(createDate) | formateDate }}</template>
        </el-table-column>


        <el-table-column
          label="修改时间"
          width="180">
          <template slot-scope="scope">{{ Date(updateDate) | formateDate }}</template>
        </el-table-column>


      </el-table>

      <div class="block">
               <el-pagination
                 @size-change="select"
                 @current-change="select"
                 :current-page.sync="currentPage"
                 :page-size="10"
                 layout="prev, pager, next, jumper"
                 :total="pageSize">
               </el-pagination>
             </div>
</div>
</template>

<script>
  import axios from 'axios'
  import Cookies from "js-cookie";
  export default {
     name: 'Property_Change',
     data () {
       return {
         dialogFormVisible:false,
         ownerId:'',
         currentPage: 1,
         pageSize: 1,
         propertyId:'',
         propertyId:'',
         recordId:'',
            tableData: [{
                    afterUserId:'',
                    afterUsername:'',
                    beforeUserId:'',
                    beforeUsername:'',
                    createDate:'',
                    propertyId:'',
                    propertyName:'',
                    propertyRecordId:'',
                    recordState:'',
                    unitId:'',

                  }]
        };
     },
     mounted:function() {
       this.showData();

     },
     methods: {
		// 主要数据展示给tableData
       showData(){
        var authorization = Cookies.get("Authorization");
        var params = {
          currentPage: 1,
          pageSize: 200,
        }
         this.axios({
             method: 'POST',
             url: '/property/showAllPropertyRecord',
             data:params,
             header:{
              'Authorization':authorization,
             	'Content-Type':'application/json;charset=UTF-8'  //如果写成contentType会报错,如果不写这条也报错
             	}
           }).then((resp)=>{
             console.log(resp)
            this.tableData=resp.data.data;
            this.pageSize = resp.data.count;
           })
       },

	   // 根据资产Id的搜索功能
       selectPropertyId(val){
        var authorization = Cookies.get("Authorization");

          this.axios({
              method: 'GET',
              
              url: '/property/getCheckRecord',
              params:{
                propertyId:this.propertyId,
              },
              header:{
               'Authorization':authorization,
              	'Content-Type':'application/json;charset=UTF-8'  //如果写成contentType会报错,如果不写这条也报错
              	}
            }).then((resp)=>{
             this.tableData=resp.data.data;
             this.pageSize = resp.data.count;
            })
        },






	   // 需审批的审核接口，val是值
       selectRecord(val){
        var authorization = Cookies.get("Authorization");

          this.axios({
              method: 'POST',
              url: '/public/checkMsg',
              params:{
                recordId:val,
              },
              header:{
               'Authorization':authorization,
              	'Content-Type':'application/json;charset=UTF-8'  //如果写成contentType会报错,如果不写这条也报错
              	}
            }).then((resp)=>{
              console.log(resp)
            })
        },
		// 申请人提交资产变更申请
       add(){
         var authorization = Cookies.get("Authorization");
         this.axios({
             method: 'POST',
             url: '/public/applyChange',
             data: {
              propertyId:this.propertyId,
              ownerId:this.ownerId
             },

             header:{
              'Authorization':authorization,
             	'Content-Type':'application/json;charset=UTF-8'  //如果写成contentType会报错,如果不写这条也报错
             	}
           })

       },


     }
   }
</script>

<style>
</style>



// WEBPACK FOOTER //
// src/components/Property/Property_Change.vue